import React from 'react';
import moment from 'moment-timezone';
import { Column } from 'ui/Table';
import { Badge } from 'ui/shadcn';
import { Check, X } from 'lucide-react';

const formatDateTime = (value: string) => {
    if (!value) return '-';
    return moment(value).tz('Asia/Seoul').format('YYYY-MM-DD HH:mm');
};

export interface BoardRow {
    id: number;
    name: string;
    description?: string;
    visible: boolean;
    categories?: Array<{ id: number; name: string }>;
    articles?: any[];
    created_at?: string;
    updated_at?: string;
}

/**
 * 카테고리 수정 컬럼은 페이지에서 onClick 주입을 위해 별도 메이커.
 * field-level 정의는 ui/Table 의 key/header 컨벤션을 따름.
 */
export const buildBoardColumns = (
    onEditCategories: (row: BoardRow) => void
): Column<BoardRow>[] => [
    {
        key: 'id',
        header: '번호',
        width: '80px',
        align: 'center',
        sortable: true,
    },
    {
        key: 'name',
        header: '게시판 이름',
        sortable: true,
    },
    {
        key: 'description',
        header: '설명',
        render: (value) => value || <span className="text-neutral-400">-</span>,
    },
    {
        key: 'visible',
        header: '공개',
        width: '90px',
        align: 'center',
        render: (value) =>
            value ? (
                <Badge variant="success">
                    <Check className="h-3 w-3" /> 공개
                </Badge>
            ) : (
                <Badge variant="secondary">
                    <X className="h-3 w-3" /> 비공개
                </Badge>
            ),
    },
    {
        key: 'categories',
        header: '카테고리',
        render: (_value, row) => {
            const names = row?.categories?.map((c) => c.name) || [];
            if (names.length === 0) return <span className="text-neutral-400">-</span>;
            return (
                <div className="flex flex-wrap gap-1">
                    {names.map((name, i) => (
                        <Badge key={i} variant="outline">
                            {name}
                        </Badge>
                    ))}
                </div>
            );
        },
    },
    {
        key: 'created_at',
        header: '생성일',
        width: '160px',
        sortable: true,
        render: (value) => (
            <span className="text-muted-foreground tabular-nums">
                {formatDateTime(value)}
            </span>
        ),
    },
];
